export default "__VITE_ASSET__47cf1118__"